import {USER_SETUP} from '../actions/const';

const initialState = {
  limit: 10,
  totalRecord: '',
  tableData: [],
  filterUsername: null,
  filterName: null,
  filterMerchant: null,
  vipMemberList: [],
  merchant: null,
  costCenter: "",
  evScannerUserList: [],
  isHideFinanceData: true,
  isHideClaimedData: true,

  isSendReceiptEmail: false,
  receiptEmailRecipient: [],
  isPrintReceiptEnabled: false,
  isReprintReceiptEnabled: false,
  reprintLimit: ""
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case USER_SETUP:
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/UserSetup.js